<template>
    <b-badge href="#" variant="secondary pr-1" @click.stop="edit">
        <i class="far fa-edit" />
    </b-badge>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: true
        }
    },

    methods: {
        edit() {
            this.$emit('edit', this.value);
        }
    }
};
</script>
